import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

import { InputTransformFn, NgxMaskDirective } from 'ngx-mask';
import { isNil } from 'lodash';

import { IInputMaskConfig } from '@pages/office/models/input-mask-config.model';
import { ControlValueAccessorBaseDirective } from '@pages/office/shared/directives/base-control-value-accessor.directive';

// NOTE: We don't use a mask for the value formatting from API to format values with two digits after the decimal point, as it does in Vista.
@Component({
    selector: 'app-input-percent',
    templateUrl: 'input-percent.component.html',
    styles: `
    :host {
      width: 100%;
    }
  `,
    imports: [NgxMaskDirective, NgClass, ReactiveFormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputPercentComponent),
            multi: true,
        },
    ]
})
export class InputPercentComponent extends ControlValueAccessorBaseDirective<string> implements OnInit {
  @Input() inputMaskConfig: IInputMaskConfig;
  @Input() inputTransformFn: InputTransformFn;

  public onBlur(): void {
    this.onChange(this.innerControl.value);
    this.onTouched();
  }

  override writeValue(value: string): void {
    this.innerControl.setValue(!isNil(value) && value.length !== 0 ? (parseFloat(value) * 100).toString() : null);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = (value: string): void => {
      fn(!isNil(value) && value.length !== 0 ? (Math.round(parseFloat(value) * 100) / 10000).toString() : null);
      this.innerControl.setValue(
        !isNil(value) && value.length !== 0 ? (Math.round((parseFloat(value) + Number.EPSILON) * 100) / 100).toFixed(2) : null,
        { emitEvent: false }
      );
    };
  }

  protected initControlAndSubscribe(): void {
    this.innerControl = new FormControl<string>(null);
  }
}
